/* eslint-disable react/jsx-one-expression-per-line */
import { TServiceHolidays } from 'feature/serviceCenters/types'

import style from './ServiceHolidays.module.scss'

// блок с уведомлением о выходных днях
export function ServiceHolidays({ holidays }: { holidays: TServiceHolidays }) {
  const { date, start, end } = holidays

  if (start) {
    return (
      <p className={style.holidays}>
        Обратите внимание, что {date} график работы отличается: {start} - {end}.
      </p>
    )
  }

  return (
    <span className={style.holidays}>
      Обратите внимание, что {date} - выходной день.
    </span>
  )
}
